function TabPanel({ children, value, index, ...other }) {

  return (
    <div
      role="tabpanel"
      style={{ height: "100%" }}
      hidden={value !== index}
      id={`tabpanel-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  )
}

export default TabPanel